var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheck = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#F1ECFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3446 8.00593C16.2161 8.0262 16.0976 8.09334 16.0083 8.19648C14.0714 10.3202 12.3068 12.4179 10.4113 14.5171L7.93715 12.3555C7.87801 12.3037 7.81012 12.2652 7.73736 12.2421C7.66461 12.219 7.58841 12.2119 7.51312 12.221C7.43784 12.2302 7.36493 12.2555 7.29858 12.2954C7.23222 12.3354 7.17371 12.3893 7.12639 12.454C7.07907 12.5187 7.04387 12.593 7.02279 12.6726C7.0017 12.7522 6.99516 12.8356 7.00353 12.9179C7.0119 13.0003 7.03502 13.0801 7.07156 13.1527C7.1081 13.2253 7.15736 13.2893 7.21652 13.341L10.0991 15.864C10.2106 15.9605 10.3507 16.0085 10.4926 15.9988C10.6345 15.9891 10.7681 15.9224 10.8677 15.8115C12.9294 13.551 14.7871 11.318 16.825 9.08346C16.9122 8.99086 16.9704 8.8705 16.9914 8.73954C17.0123 8.60859 16.9949 8.47374 16.9416 8.35426C16.8884 8.23477 16.8019 8.13675 16.6947 8.0742C16.5875 8.01164 16.465 7.98775 16.3446 8.00593Z",
    fill: "#5F30E2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.11da49ef26eebd89b0f6b6e3683168fa.svg";